import { Skeleton } from "@/components/ui/Skeleton";
import { HeaderText } from "@/components/ui/Text";

import { cn } from "@/lib/utils";
import {
  AccordionContent,
  AccordionHeader,
  AccordionItem,
  AccordionRoot,
} from "./AccordionComponents";

interface AccordionProps {
  accordionTitleText: string;
  accordionBody: string | React.JSX.Element | React.JSX.Element[];
  collapsible?: boolean;
  onClick: () => void;
  customAccordionHeader?: React.JSX.Element | null;
  defaultExpanded?: boolean;
  isLoading?: boolean;
  rightChevron?: boolean;
  compact?: boolean;
}

const AccordionLoadingSkeleton = () => (
  <div className="flex flex-col gap-2">
    <Skeleton className="h-2 w-11/12" />
    <Skeleton className="h-2" />
    <Skeleton className="h-2 w-5/6" />
  </div>
);

export function Accordion({
  accordionTitleText,
  accordionBody,
  onClick,
  collapsible = true,
  customAccordionHeader = null,
  defaultExpanded = false,
  isLoading = false,
  rightChevron = false,
  compact = false,
}: AccordionProps) {
  const itemValue = "item-1";
  return (
    <AccordionRoot
      collapsible={collapsible}
      defaultValue={defaultExpanded ? itemValue : undefined}
    >
      <AccordionItem value={itemValue}>
        {customAccordionHeader || (
          <AccordionHeader
            onClick={onClick}
            rightChevron={rightChevron}
            compact={compact}
          >
            <HeaderText size="sm" className="cursor-pointer">
              {accordionTitleText}
            </HeaderText>
          </AccordionHeader>
        )}
        <AccordionContent className={cn("p-3", compact && "p-1")}>
          {isLoading ? <AccordionLoadingSkeleton /> : accordionBody}
        </AccordionContent>
      </AccordionItem>
    </AccordionRoot>
  );
}
